import {
  clearCandidateSession,
  getCandidateToken,
  syncCandidateSessionFromApi,
} from "./candidateSession";
import { refreshAccessTokenSilently } from "../admin/infra/refreshToken";

function isJwtExpired(token: string): boolean {
  try {
    const base64 = token.split(".")[1]?.replace(/-/g, "+").replace(/_/g, "/");
    if (!base64) return true;
    const payload = JSON.parse(atob(base64)) as { exp?: number };
    if (typeof payload.exp !== "number") return false;
    return Date.now() >= payload.exp * 1000;
  } catch {
    return true;
  }
}

export async function validateCandidateSession(): Promise<boolean> {
  const token = getCandidateToken();
  const userId = localStorage.getItem("rh-userId");

  if (!token || !userId) {
    if (token || userId) {
      clearCandidateSession();
    }
    return false;
  }

  let activeToken = token;
  if (isJwtExpired(activeToken)) {
    const refreshed = await refreshAccessTokenSilently();
    if (!refreshed) {
      clearCandidateSession();
      return false;
    }
    activeToken = refreshed;
  }

  const endpoint = `${process.env.REACT_APP_API_URL}/candidate/user/get`;
  try {
    const response = await fetch(endpoint, {
      headers: { Authorization: `Bearer ${activeToken}` },
    });

    if (response.status === 401 || response.status === 404) {
      clearCandidateSession();
      return false;
    }

    if (!response.ok) {
      clearCandidateSession();
      return false;
    }

    const data = await response.json();
    if (!data || typeof data !== "object" || !data.pessoal_nome) {
      clearCandidateSession();
      return false;
    }

    syncCandidateSessionFromApi(data);
    return true;
  } catch {
    clearCandidateSession();
    return false;
  }
}
